import { Card, CardHeader, CardContent } from "@repo/ui/components/card";
import { Button } from "@repo/ui/components/button";
import { BusyButton } from "@repo/ui/components/busy-button";
import { useState } from "react";
import { IconArrowLeft } from "central-icons/IconArrowLeft";
import { IconArrowRotateCounterClockwise } from "central-icons/IconArrowRotateCounterClockwise";
import { IconExclamationTriangle } from "central-icons/IconExclamationTriangle";
import { IconWarningSign } from "central-icons/IconWarningSign";

export function FatalError(props: {
  message: string;
  onReload?: () => void;
  onGoBack?: () => void;
}) {
  const { message, onReload, onGoBack } = props;
  const [isReloading, setIsReloading] = useState(false);
  return (
    <Card className="text-center w-full max-w-sm">
      <CardHeader>
        <h2 className="text-lg text-destructive-foreground flex items-center justify-center gap-2 font-semibold">
          <IconExclamationTriangle size={24} /> Whoops, something went wrong
        </h2>
      </CardHeader>
      <CardContent className="text-sm text-destructive-foreground space-y-4">
        <div className="bg-destructive-tertiary border border-destructive/20 rounded-xl p-2 mb-6">
          <code className="inline-block text-sm">{message}</code>
        </div>
        <div className="flex items-center justify-center gap-1">
          {onGoBack && (
            <Button variant="destructive-outline" onClick={() => onGoBack()}>
              <IconArrowLeft />
              Go back
            </Button>
          )}
          {onReload && (
            <BusyButton
              variant="destructive"
              onClick={() => {
                setIsReloading(true);
                onReload?.();
              }}
              busy={isReloading}
              icon={<IconArrowRotateCounterClockwise />}
              label="Reload"
              busyLabel="Reloading..."
            >
              Reload
            </BusyButton>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
